import { render, staticRenderFns } from "./WorkAdd.vue?vue&type=template&id=563a79a3&"
import script from "./WorkAdd.vue?vue&type=script&lang=js&"
export * from "./WorkAdd.vue?vue&type=script&lang=js&"
import style0 from "./WorkAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports